import '../components/PaymentSolutions/payment-solutions.css'
import ExpertiseServices from "../components/PaymentSolutions/ExpertiseServices";
import Header from "../components/PaymentSolutions/Header"
import TechnologyStack from "../components/PaymentSolutions/TechnologyStack";
import MarketsWeServe from "../components/PaymentSolutions/MarketsWeServe"

import TransitionPage from '../utils/TransitionPage';
import { Helmet } from 'react-helmet-async';

const PaymentSolutions = () => {
  return (
    <>
      <Helmet>
          <title>Payment & Subscription Systems | Advante Digital</title>
          <meta name="description" content="We support and improve payment and subscription systems on real platforms: Stripe, recurring billing, credits, commissions, pricing rules, reporting, and payment issue resolution with AI-assisted engineering and controlled deployment."/>
          <meta name='keywords' content='payment systems, subscriptions, Stripe, recurring billing, marketplace payments, commissions, payment issue resolution, controlled deployment'/>
      </Helmet>
      <Header />
      <TechnologyStack />
      <ExpertiseServices />
      <MarketsWeServe />
    </>
  );
}

export default TransitionPage(PaymentSolutions ); 